module.exports = __webpack_public_path__ + "static/media/flight404-2.7cd364fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/presentation/flight404-2.jpg
// module id = 422
// module chunks = 12